import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-w-full rmd:tw-w-[540px] tw-max-h-[570px] tw-flex tw-flex-col tw-gap-4 tw-overflow-x-hidden" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-3" }
const _hoisted_3 = { class: "tw-flex tw-flex-col tw-gap-3" }
const _hoisted_4 = { class: "tw-w-full" }
const _hoisted_5 = { class: "tw-w-full tw-pt-4 tw-border-t-dashed-custom tw-flex tw-justify-end tw-items-center tw-gap-3" }

import { computed, ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import InputField from "@/core/components/common/InputField.vue";
import InputSelect from "@/core/components/common/InputSelect.vue";
import UploadForm from "@/core/components/forms/Upload.vue";
import { PROPERTY_STORE } from "@/store/modules/property";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddRicsReportModal',
  emits: ["on-close", "on-success"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const store = useStore();
const route = useRoute();

const form = reactive({
  name: "",
  isActive: true,
  attachments: [],

  disableButton: false,
  isReadyToSubmit: false,
  formValue: {},
  isSubmitting: false,
  isUploading: false,
  isLoading: false,
});

const state = reactive({
  loading: false,
  dateInput: "",
});

const propertyId = computed(() => route?.params?.propertyId);

const hasAttachments = computed(() => {
  return form.attachments.length > 0;
});

const onCloseModal = () => {
  emits("on-close");
};

const onProgressUpload = () => {
  form.isUploading = true;
  form.isLoading = true;
};

const updateFileOnSuccess = () => {
  form.isUploading = false;
  form.isLoading = false;
};

const onHandleError = () => {
  form.isUploading = false;
  form.isLoading = false;
};

const onCreateRics = async () => {
  if (!propertyId.value) return;
  const propertyIdParse = parseInt(propertyId.value, 10);
  console.log(form.attachments, "attachments");
  let attachmentsModified = [];
  if (form.attachments && form.attachments.length) {
    attachmentsModified = form.attachments.map((attachment) => {
      return {
        ...attachment,
        src: attachment.publicUrl,
      };
    });
  }
  try {
    state.loading = true;
    const payload = {
      formData: {
        propertyId: propertyIdParse,
        name: form.name,
        attachments: attachmentsModified,
        isActive: true,
      },
      propertyId: propertyIdParse,
    };
    const response = await store.dispatch(
      `${PROPERTY_STORE}/createRicsReport`,
      payload
    );
  } catch (error) {
    console.log(error);
  } finally {
    state.loading = false;
    emits("on-success");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GeneralDialog, {
    onOnClose: onCloseModal,
    headerTitle: "Add New Report"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Text, {
            variant: "span",
            textWeight: "400"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Report Name")
            ]),
            _: 1
          }),
          _createVNode(InputField, {
            placeholder: "Enter Report Name",
            modelValue: form.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Text, {
            variant: "span",
            textWeight: "400"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Upload Document")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(UploadForm, {
              class: "!tw-w-full",
              listType: "picture",
              record: form,
              allowMultiple: false,
              attachmentSources: [],
              useCustomUploadIcon: false,
              useDragTrigger: true,
              onOnProgressUpload: onProgressUpload,
              onOnUploadSuccess: updateFileOnSuccess,
              onOnHandleError: onHandleError
            }, null, 8, ["record"])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Button, {
          class: "!tw-w-auto",
          variant: "secondary",
          disabled: state.loading,
          label: "close",
          isActive: true,
          onClick: onCloseModal
        }, null, 8, ["disabled"]),
        _createVNode(Button, {
          variant: "accent",
          class: "!tw-w-auto",
          disabled: state.loading,
          isLoading: state.loading,
          label: "save",
          isActive: true,
          onClick: onCreateRics
        }, null, 8, ["disabled", "isLoading"])
      ])
    ]),
    _: 1
  }))
}
}

})